<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="/img/brand/Marvelous.svg" alt="Logo Marvelous">
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand" @click="goToHome()">
          <h4>Marvelous</h4>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <li>
          <router-link to="/about" class="nav-link">{{ $t('nav.about.title') }}</router-link>
        </li>
        <li>
          <router-link to="/relations" class="nav-link">{{ $t('nav.relations.title') }}</router-link>
        </li>
        <li>
          <router-link to="/references" class="nav-link">{{ $t('nav.references.title') }}</router-link>
        </li>
        <li>
          <router-link to="/contact" class="nav-link">{{ $t('nav.contact.title') }}</router-link>
        </li>
      </ul>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <a target="_blank" rel="noopener" href="https://www.linkedin.com/in/marlous-molder"
             class="btn btn-neutral btn-icon-only btn-linkedin btn-round btn-lg" data-toggle="tooltip"
             data-original-title="Like us">
            <i class="fa fa-linkedin"></i>
          </a>
        </li>
        <!-- Contact button -->
        <!-- <li class="nav-item d-none d-lg-block ml-lg-4">
            <a href="#" target="_blank" rel="noopener"
               class="btn btn-neutral btn-icon">
                <span class="btn-inner--icon">
                <i class="fa fa-envelope mr-2"></i>
                </span>
                <span class="nav-link-inner--text">Start a conversation</span>
            </a>
        </li> -->
        <LanguageSwitch class="nav-item d-none d-lg-block ml-lg-4"/>
      </ul>
    </base-nav>
  </header>
</template>
<script>
  import LanguageSwitch from "@/components/LanguageSwitch.vue";
  import BaseNav from "@/components/BaseNav";
  import BaseDropdown from "@/components/BaseDropdown";
  import CloseButton from "@/components/CloseButton";

  import projectsData from '@/data/clients.js';
  import workshopsData from '@/data/workshops.js';

  export default {
    components: {
      BaseNav,
      CloseButton,
      BaseDropdown,
      LanguageSwitch
    },
    data() {
      return {
        projects: projectsData,
        workshops: workshopsData
      }
    },
    methods: {
      goToHome() {
        if (this.$route.path !== '/') {
          this.$router.push({path: '/'});
        }
      }
    }
  };
</script>

<style lang="scss">
  .icon-logo {
    padding: 3px;

    img {
      width: 36px;
    }
  }
</style>
